
import React, { Fragment, useState } from 'react'
import { Alert } from 'react-bootstrap'
import Swal from 'sweetalert2'

import { isValidEmail } from '@/Helpers/TeamsHelper'

import useTranslation from '@/Hooks/UseTranslation'
import { useTeams } from '@/Hooks/UseTeam'

import InputText from '@/Components/InputText/InputText'

import './InviteByMailTab.scss'

const InviteByMailTab = () => {

  const { t } = useTranslation()

  const { inviteByMail } = useTeams()

  const [email, setEmail] = useState('')
  const [sendingMail, setSendingMail] = useState(false)

  const handleInviteByMail = async () => {

    if (!isValidEmail(email)) {

      Swal.fire({
        title: t('TEAMMEMBER_SELECTOR:InvalidMailAlertTitle'),
        text: t('TEAMMEMBER_SELECTOR:InvalidMailAlertContent'),
        icon: 'error',
        confirmButtonText: t('TEAMMEMBER_SELECTOR:InvalidMailAlertConfirmButton'),
        width: '500px',
      })

      return
    }

    setSendingMail(true)

    await inviteByMail(email)

    setSendingMail(false)

    Swal.fire({
      title: t('TEAMS:InviteSentTitle'),
      text: t('TEAMS:InviteSentContent'),
      icon: 'success',
      confirmButtonText: t('TEAMS:InviteSentConfirmButton'),
      width: '500px'
    })
  }

  return (
    <div className='invite-by-mail-tab'>
      <div className="mb-2">
        <InputText
          placeholder={t('TEAMMEMBER_SELECTOR:InputMailPlaceholder')}
          icon={(
            <i className="far fa-envelope fa-fw" style={{
              fontSize: '1.5rem',
              lineHeight: '1rem',
              display: 'flex',
              marginLeft: '.25rem',
            }}></i>
          )}
          value={email}
          onChange={setEmail}
          disabled={sendingMail}
        />
      </div>
      <div>
        <Alert variant="info" style={{ borderRadius: '.25rem' }}>
          {t('TEAMMEMBER_SELECTOR:MailDisclaimer')}
        </Alert>
      </div>
      <div>
        <button className="submit-button"
          onClick={() => handleInviteByMail()}
          disabled={sendingMail}
        >
          {sendingMail ? (
              <>
                <i className="fas fa-spinner fa-spin fa-fw"></i> {t('TEAMMEMBER_SELECTOR:SendingInvitationButton')}
              </>
            ) : (
              <>
                <i className="far fa-envelope fa-fw"></i> {t('TEAMMEMBER_SELECTOR:SendInvitationButton')}
              </>
            )}
        </button>
      </div>
    </div>
  )
}

export default InviteByMailTab
